const sizeTokens = {
  "icon.small": 16,
  "icon.regular": 20,
  "icon.large": 24,
  "icon.huge": 32,
  "icon.massive": 40
};
export { sizeTokens };
//# sourceMappingURL=Icon.tokens.mjs.map
